import React from "react";
import { motion } from "framer-motion";

const ProductCardV2 = ({ name, logo, productImage, link, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.5,
        delay: index * 0.2,
        ease: "easeOut",
      }}
      className={`relative mx-auto w-[350px]`}
    >
      {/* Gradient Border Container (Animasyonlu) */}
      <motion.div
        className="p-[3px] rounded-2xl"
        initial={{ background: "linear-gradient(to bottom, #FF6A3D, #735DFF)" }}
        whileHover={{
          background: [
            "linear-gradient(to bottom, #FF6A3D, #735DFF)",
            "linear-gradient(to bottom, #735DFF, #FF6A3D)",
            "linear-gradient(to bottom, #FF3D77, #3D9FFF)",
          ],
          transition: {
            duration: 0.6,
            ease: "easeInOut",
            repeat: Infinity,
            repeatType: "reverse",
          },
        }}
      >
        {/* İçerik Kutusu */}
        <div className="bg-white rounded-xl p-6 shadow-md">
          {/* Logo ve Ürün Görseli Aynı Satırda */}
          <div className="flex items-center justify-between mb-12">
            <motion.div className="w-1/2 flex justify-start">
              <motion.img
                src={logo}
                alt={`${name} logo`}
                // className="h-16"
                whileHover={{ scale: 1.15 }}
              />
            </motion.div>

            <motion.div className="w-1/2 flex justify-end">
              <motion.img
                src={productImage}
                alt={name}
                className="h-32 object-contain"
                whileHover={{ scale: 1.1, rotate: 5 }}
              />
            </motion.div>
          </div>

          {/* <h2 className="text-lg font-semibold text-gray-900 text-center mt-4">
            {name}
          </h2> */}

          {/* Satın Al Butonu */}
          <motion.a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full mt-4 py-3 bg-black text-white font-medium text-sm rounded-lg text-center hover:bg-neutral-800 transition shadow-md"
            style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)" }}
          >
            Satın Al
          </motion.a>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ProductCardV2;
